import { FileDownloadService } from "@topline/services/fileDownloadService";
import moment from "moment";
import { ImsIoMarketDataProvider } from "../services/imsIoMarketDataProvider";
import ng from "angular";
import { ForecastParametersProvider } from "../../Forecast/services/forecastParametersProvider";
import { ToasterService } from "@topline/services/toasterService";
import { IMSIODataService } from "../../Forecast/services/initializeAndRefresh/imsIODataService";
import { GridValueEditorService } from "../../Forecast/components/common/gridValueEditor/service/gridValueEditorService";
import { Gen } from "@topline/services/api";

class FileMarketValueComponentController {
    public marketId: string;
    public historicalDataStartDate: Date;
    public historicalDataEndDate: Date;
    public filters: Gen.MarketFilterDTO[];
    public currency: string;
    public countryCode: string;
    public showYears: boolean = true;
    public isCollapsedMarketValue: boolean = true;
    public config: $TSFixMe;
    public marketValue: $TSFixMe;
    public serverOperation: $TSFixMe;
    public yearlyMarketValueGridOptions: $TSFixMe;
    public monthlyMarketValueGridOptions: $TSFixMe;

    static $inject = [
        ImsIoMarketDataProvider.componentName,
        ForecastParametersProvider.componentName,
        IMSIODataService.componentName,
        GridValueEditorService.componentName,
        ToasterService.componentName,
        FileDownloadService.componentName,
        "$q",
        "$scope"
    ];

    constructor(
        private marketDataProvider: ImsIoMarketDataProvider,
        private forecastParametersProvider: ForecastParametersProvider,
        private imsIODataService: IMSIODataService,
        private gridValueEditorService: GridValueEditorService,
        private toasterService: ToasterService,
        private fileDownloadService: FileDownloadService,
        private $q: ng.IQService,
        private $scope: ng.IScope
    ) {}

    $onInit() {
        this.serverOperation = this.getConfig().then(() => {
            this.$scope.$watch(
                () => this.filters,
                () => this.loadMarketValue(),
                true
            );
            this.$scope.$watch(
                () => this.currency,
                () => this.loadMarketValue(),
                true
            );
            this.$scope.$watch(
                () => this.countryCode,
                () => this.loadMarketValue(),
                true
            );
        });
    }

    downloadSkuReport() {
        const apiEndpoint = "/api/ims-io/market/value/skus/report";

        this.toasterService.showReportGenerateBusyIndicator(
            () =>
                this.fileDownloadService.downloadFilePost(apiEndpoint, "MarketImsIoSkus.xlsx", {
                    filters: this.filters,
                    startMonth: this.config.startDate,
                    endMonth: this.config.endDate,
                    currency: this.currency,
                    countryCode: this.countryCode
                }),
            "MARKET.SKUS_REPORT_GENERATING",
            "MARKET.SKUS_REPORT_GENERATED"
        );
    }

    isDownloadEnabled() {
        return !!(this.config?.startDate && this.config?.endDate && this.currency && this.countryCode);
    }

    private loadMarketValue() {
        if (!this.filters || !this.currency || !this.countryCode) return;

        return this.marketDataProvider
            .getMarketData(this.filters, this.config.startDate, this.config.endDate, this.currency, this.countryCode)
            .then((data: $TSFixMe) => {
                this.marketValue = data;
                this.populateDataToGridOptions();
            });
    }

    private getConfig() {
        return this.$q
            .all([this.forecastParametersProvider.getForecastDefaults(), this.imsIODataService.getLatestData()])
            .then((results: $TSFixMe) => {
                const historicalDataLengthInYears = results[0].defaultHistoricalDataPeriod;
                const imsEndDate = results[1].dataTo;
                this.config = {
                    historicalDataLengthInYears,
                    imsEndDate,
                    imsImportDate: results[1].importDate,
                    startDate: this.historicalDataStartDate,
                    endDate: this.historicalDataEndDate
                };
            });
    }

    private populateDataToGridOptions() {
        if (!this.marketValue) return;

        this.yearlyMarketValueGridOptions = {
            gridName: "yearlyImsIoMarketValueGridOptions",
            header: _.range(this.config.startDate.getFullYear(), this.config.endDate.getFullYear() + 1),
            readOnly: true,
            valuesDecimalPlaces: 0,
            gridData: [
                {
                    header: "{{ 'QUANTITY' | translate}}",
                    values: this.marketValue.yearly?.volume || []
                },
                {
                    header: "{{ 'VALUE' | translate}}",
                    values: this.marketValue.yearly?.value || []
                }
            ]
        };

        this.monthlyMarketValueGridOptions = {
            gridName: "monthlyImsIoMarketValueGridOptions",
            header: this.gridValueEditorService.prepareHeaderData(this.config.startDate, this.config.endDate),
            readOnly: true,
            valuesDecimalPlaces: 0,
            gridData: [
                {
                    header: "{{ 'QUANTITY' | translate}}",
                    values: this.marketValue.monthly?.volume || []
                },
                {
                    header: "{{ 'VALUE' | translate}}",
                    values: this.marketValue.monthly?.value || []
                }
            ]
        };
    }
}

export class FileMarketValueComponent implements ng.IComponentOptions {
    static componentName = "fileMarketValue";
    bindings = {
        marketId: "<",
        historicalDataStartDate: "<",
        historicalDataEndDate: "<",
        filters: "<",
        currency: "<",
        countryCode: "<"
    };
    controller = FileMarketValueComponentController;
    template = require("./fileMarketValueComponent.html");
}

angular.module("topline.modules").component(FileMarketValueComponent.componentName, new FileMarketValueComponent());
